// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { NodeValue, NodeValueT, verifyNodeValue } from "./node-value";

/**
 * Inbound mapping: a monitored node reaching a value -> emit an LN2 message.
 */
export class NodeValueToMessageEntry implements flatbuffers.IUnpackableObject<NodeValueToMessageEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeValueToMessageEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeValueToMessageEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeValueToMessageEntry,
  ): NodeValueToMessageEntry {
    return (obj || new NodeValueToMessageEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsNodeValueToMessageEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeValueToMessageEntry,
  ): NodeValueToMessageEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeValueToMessageEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  key(obj?: NodeValue): NodeValue | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeValue()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  value(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startNodeValueToMessageEntry(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, keyOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endNodeValueToMessageEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // value
    return offset;
  }

  unpack(): NodeValueToMessageEntryT {
    return new NodeValueToMessageEntryT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.value() !== null ? this.value()!.unpack() : null,
    );
  }

  unpackTo(_o: NodeValueToMessageEntryT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.value = this.value() !== null ? this.value()!.unpack() : null;
  }

  unpackFields(...fields: string[]): NodeValueToMessageEntryT {
    const t = new NodeValueToMessageEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("value")) {
      t.value = this.value() !== null ? this.value()!.unpack() : null;
    }
    return t;
  }
}

export class NodeValueToMessageEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: NodeValueT | null = null,
    public value: ValuedMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const key = this.key !== null ? this.key!.pack(builder) : 0;
    const value = this.value !== null ? this.value!.pack(builder) : 0;

    NodeValueToMessageEntry.startNodeValueToMessageEntry(builder);
    NodeValueToMessageEntry.addKey(builder, key);
    NodeValueToMessageEntry.addValue(builder, value);

    return NodeValueToMessageEntry.endNodeValueToMessageEntry(builder);
  }

  clone(): NodeValueToMessageEntryT {
    const obj = new NodeValueToMessageEntryT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.value = this.value !== null ? this.value!.clone() : null;
    return obj;
  }

  equals(other: NodeValueToMessageEntryT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.value !== null && other.value !== null) {
      if (!this.value!.equals(other.value!)) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyNodeValueToMessageEntry(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeValue(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
